/**
 * 接口统一管理
 */
import common from "./common.js"
import system from "./system.js"
import announcement from "./announcement.js"
import businessInformation from "./businessInformation.js"
import cooperationApplication from "./cooperationApplication.js"
import franchisee from "./franchisee.js"
import settlement from "./settlement.js"
import supplier from "./supplier.js"
import product from "./product.js"
import storeManage from "./storeManage.js"
import orderManage from "./orderManage.js"
import marketing from "./marketing.js"
import inventory from "./inventory.js"
import formalProject from "./formalProject.js"
import personnelMatters from "./personnelMatters"
import experienceProject from "./experienceProject"
import customerRelations from "./customerRelations.js"
import device from "./device.js"
import opinion from "./opinion.js"
import carouselManage from "./carouselManage.js"
import reserveManage from "./reserveManage.js"
import activity from "./activity.js"
import customerService from "./customerService.js"
import user from "./user.js"

const apiAll = [common, system, announcement, businessInformation, cooperationApplication, franchisee, supplier, settlement, product, storeManage, orderManage, marketing, inventory, formalProject, personnelMatters, experienceProject, customerRelations, device, opinion, carouselManage, reserveManage, activity, customerService, user]

// 判断接口是否已存在
function isKeyQepeat(arr) {
  let keyArr = [],
    apiObj = {}
  arr.forEach(item => {
    keyArr.push(...Object.keys(item))
    Object.assign(apiObj, item)
  })
  try {
    keyArr.forEach((item, i, arr) => {
      if (arr.indexOf(item) !== i) {
        throw new Error(`接口 key 重复项: ${item}`)
      }
    })
  } catch (error) {
    console.error("[错误]:", error)
    return null
  }
  return apiObj
}
const apiDesc = isKeyQepeat(apiAll)
//进行统一导出
export default {
  ...apiDesc,
}
